'use strict';

const SELECTORS = {
    promotionDetail: '.js-promotion-pdp',
    assemblyDetail: '.js-assembly-pdp',
    assemblyDetailDefault : '.js-product-option-default',
    assemblyDetailCustomized : '.js-product-option-customized',
    assemblyOptions : 'select.product-option',
    specialProduct: '.js-special-product-pdp',
    addToCartWrap: '.js-addToCart-wrap',
    promotionAccordion: '.js-promotion-accordion',
    assemblyAccordion: '.js-assembly-accordion',
    specialAccordion: '.js-special-product',
    specialAccordionButton: '.js-special-product-button',
    headerMain: '.js-header__main',
    pdpMain: '.js-pdp-main',
    footerBottom: '.js-footer-bottom',
    giftCardQuantity: 'select.js-giftcard-selectable-quantity',
    giftCardQuantityInvalidFeedback: '#AnzahlDesc.invalid-feedback',
    addToCartGifCardButton: 'button.js-add-to-cart-giftcard'
};

const CLASSES = {
    promoClosed: 'cc-pdp__promotion-detail--closed',
    assemblyClosed: 'cc-pdp__assembly-detail--closed',
    specialClosed: 'cc-pdp__product-special-detail--closed',
    fixed: 'cc-fixed'
}

/**
 * Handles the toggling of promotion and assembly details.
 */
class DetailToggle {
    constructor() {
        this.togglePromotionDetail = this.togglePromotionDetail.bind(this);
        this.toggleAssemblyDetail = this.toggleAssemblyDetail.bind(this);
        this.toggleSpecialProduct = this.toggleSpecialProduct.bind(this);
        this.initEvents();
    }

    isSafari() {
        return $('body').hasClass('cc-safari');
    } 

    initEvents() {
        $('body').on('show.bs.collapse hide.bs.collapse', SELECTORS.promotionAccordion, this.togglePromotionDetail);
        $('body').on('click', SELECTORS.assemblyDetail, this.toggleAssemblyDetail);
        $('body').on('change', SELECTORS.assemblyOptions,this.clearAssemblyErrorMessages);
        $('body').on('change', SELECTORS.giftCardQuantity ,this.handleGiftCardQuantityChange);
        $('body').on('show.bs.collapse hide.bs.collapse', SELECTORS.specialAccordionButton, this.toggleSpecialProduct);
    }

    togglePromotionDetail() {
        $(SELECTORS.promotionDetail).toggleClass(CLASSES.promoClosed);
    }

    handleGiftCardQuantityChange()
    {
        let quantity = $(SELECTORS.giftCardQuantity).val();
        if (quantity > 0){
            $(SELECTORS.addToCartGifCardButton).prop('disabled', false);
            $(SELECTORS.giftCardQuantityInvalidFeedback).removeClass('cc-message--visible').text('');
        }
    }

    clearAssemblyErrorMessages() {
        $('.cc-pdp__product-options').find('.form-control.cc-invalid').removeClass('cc-invalid');
        $('.cc-pdp__product-options').find('.invalid-feedback').removeClass('cc-message--visible').text('');
        $('.cc-pdp__product-options').find('.cc-form__wrap--error').removeClass('cc-form__wrap--error');
        $('.cc-pdp__product-options').find('.cc-form__radio').removeClass('cc-form__radio-invalid');
        $('.cc-pdp__product-options').find('.cc-form__invalid').addClass('d-none');
    }

    toggleAssemblyDetail() {
        this.clearAssemblyErrorMessages();
        let accordion = $(SELECTORS.assemblyAccordion);
        let isDefault = $(SELECTORS.assemblyDetailDefault).is(':checked');
        let defaultOption = $(SELECTORS.assemblyOptions + ' option[default]');
        let placeholder = $(SELECTORS.assemblyOptions + ' option[placeholder]');
        let options = $(SELECTORS.assemblyOptions + ' option');
        let dropdownButton = $(SELECTORS.assemblyOptions + ' + button');
        let dropdownButtonText = $(SELECTORS.assemblyOptions + ' + button .filter-option-inner-inner');
        
        if (isDefault) {
            options.removeClass("selected");
            defaultOption.addClass("selected");
            accordion.addClass(CLASSES.assemblyClosed);
        } else {
            if (accordion.hasClass(CLASSES.assemblyClosed)) {
                options.removeClass("selected");
                placeholder.addClass("selected");
                dropdownButton.attr("title",placeholder.text().trim());
                dropdownButton.addClass("bs-placeholder");
                dropdownButtonText.text(placeholder.text());
                accordion.removeClass(CLASSES.assemblyClosed);
            }
        }
    }

    toggleSpecialProduct() {
        $(SELECTORS.specialProduct).toggleClass(CLASSES.specialClosed);
    }
}

/**
 * Manages the add to cart position based on scroll and viewport.
 */
class AddToCartPosition {
    constructor($element) {
        this.$element = $element || $(SELECTORS.addToCartWrap);
        this.$header  = $(SELECTORS.headerMain);
        this.$footer  = $(SELECTORS.footerBottom);
        if (!this.$element.length) return;

        // Defaults, so that apply() does not set the css class "fixed" too early
        this.elInView = true;
        this.footerInView = false;

        this.headerHeight = this.$header.outerHeight(true) || 0;

        // Build Observer
        this.makeFooterObserver();
        this.makeElObserver();

        // Resize-Handling
        this.onResize = () => {
        const h = this.$header.outerHeight(true) || 0;
        if (h !== this.headerHeight) {
            this.headerHeight = h;
            // elObserver needs new rootMargin -> reinitialize
            this.elObserver?.disconnect();
            this.makeElObserver();
            this.apply();
        }
        };
        this.attachResizeListeners();

        // Visibility handling: Tab minimized/other tab -> pause; back -> resume
        this.onVisibility = () => {
            if (document.hidden) {
                this.disconnectObservers();
            } else {
                this.connectObservers();
            }
        };
        document.addEventListener('visibilitychange', this.onVisibility);
    }

    makeElObserver() {
        this.elObserver = new IntersectionObserver(
            ([entry]) => {
                this.elInView = !!entry?.isIntersecting;
                this.apply();
            },
            { root: null, rootMargin: `-${this.headerHeight}px 0px 0px 0px`, threshold: 0 }
        );
        this.elObserver.observe(this.$element[0]);
    }

    makeFooterObserver() {
        this.footerObserver = new IntersectionObserver(
            ([entry]) => {
                this.footerInView = !!entry?.isIntersecting;
                this.apply();
            },
            { root: null, threshold: 0 }
        );
        if (this.$footer[0]) this.footerObserver.observe(this.$footer[0]);
    }

    attachResizeListeners() {
        if ('ResizeObserver' in window && this.$header[0]) {
            this.headerRO = new ResizeObserver(() => this.onResize());
            this.headerRO.observe(this.$header[0]);
        } else {
            window.addEventListener('resize', this.onResize);
            window.addEventListener('orientationchange', this.onResize);
        }
    }

    detachResizeListeners() {
        this.headerRO?.disconnect();
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('orientationchange', this.onResize);
    }

    apply() {
        const shouldFix = this.elInView === false && this.footerInView !== true;
        const hasFixed  = this.$element.hasClass(CLASSES.fixed);
        if (shouldFix !== hasFixed) {
            this.$element.toggleClass(CLASSES.fixed, shouldFix);
        }
    }

    disconnectObservers() {
        this.elObserver?.disconnect();
        this.footerObserver?.disconnect();
        this.detachResizeListeners();
    }

    connectObservers() {
        this.headerHeight = this.$header?.outerHeight(true) || 0;
        this.makeElObserver();
        this.makeFooterObserver();
        this.attachResizeListeners();
        this.apply();
    }
}

$(() => {
    new DetailToggle();
    if (window.isMobile && $(SELECTORS.addToCartWrap).length > 0) {
        new AddToCartPosition();

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const addedNode of mutation.addedNodes) {
                    if (!(addedNode instanceof Element)) continue;
                    addedNode.querySelectorAll?.(SELECTORS.addToCartWrap).forEach(el => new AddToCartPosition());
                }
            }
        });
        observer.observe(document.querySelector(SELECTORS.pdpMain), { childList: true, subtree: true });
    }
});